import axios from "axios";
import router from "../router";
import store from "../store";
import { USER } from "../store/actions";

const ddApi = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL ? process.env.VUE_APP_BASE_URL : "/api/",
  headers: {
    "Content-type": "application/json"
  }
});

// TODO: Grabbed from axios readme, but wasn't working
// ddApi.interceptors.request.use(
//   config => {
//     if (config.data instanceof FormData) {
//       Object.assign(config.headers, config.data.getHeaders());
//     }
//     return config;
//   }
// );

ddApi.interceptors.response.use(
  response => response,
  error => {
    const response = error.response;

    if (response && response.status === 401) {
      if (response.status === 401) {
        store.dispatch(`user/${USER.LOGOUT}`);
        router.push({ path: "/login" });
      }
    }

    return Promise.reject(error);
  }
);

export default ddApi;
